export enum MediaItemAlignmentMenuItemAlignmentType {
    Center,
    Left,
    Right,
}

export interface IMediaItemAlignmentMenuItem {
    label: string;
    alignmentType: number;
    mediaItemClass: string;
}

export const FiTextItemMediaPanelAlignmentMenuItems: IMediaItemAlignmentMenuItem[] = [
    {
        label: 'alignment.left',
        alignmentType: MediaItemAlignmentMenuItemAlignmentType.Left,
        mediaItemClass: 'fi-text-item-media-item-alignment-left',
    },
    {
        label: 'alignment.center',
        alignmentType: MediaItemAlignmentMenuItemAlignmentType.Center,
        mediaItemClass: 'fi-text-item-media-item-alignment-center',
    },
    {
        label: 'alignment.right',
        alignmentType: MediaItemAlignmentMenuItemAlignmentType.Right,
        mediaItemClass: 'fi-text-item-media-item-alignment-right',
    },
];
